/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import _ from 'lodash';
import { connect } from 'react-redux';
import * as actions from '../action';

function BusinessActivityNewPermit({
  data,
  mode,
  formData,
  handleChangeInput,
  handleChangeSelect,
  handleChangeNature,
  handleFilterLineBusinessInfo,
  handleFilterMayorFee,
}) {
  return (
    <table>
      <thead>
        <tr>
          <td>Line of Business</td>
          <td>Nature of Business</td>
          <td>Capital Investment</td>
          <td>Mayor`s Fee</td>
        </tr>
      </thead>
      <tbody>
        {_.isEmpty(data) ? (
          <tr className="w-100">
            <td colSpan="5" className="text-center border-top p-4 text-muted">
              This Section is Empty
            </td>
          </tr>
        ) : (
          <React.Fragment>
            {mode.businessActivity === 0 ? (
              data.map(item => (
                <tr key={item.id}>
                  <td className="border-top">{_.get(item, 'line_business')}</td>
                  <td className="border-top">{_.get(item, '_nature_business_name')}</td>
                  <td className="border-top">{_.get(item, 'capitalization')}</td>
                  <td className="border-top">{_.get(item, 'mayors_fee_label')}</td>
                </tr>
              ))
            ) : (
              data.map((item, i) => (
                <tr key={item.id}>
                  <td className="border-top">{_.get(item, 'line_business')}</td>
                  <td className="border-top p-2">
                    <Select
                      value={
                        handleFilterLineBusinessInfo(_.get(item, 'line_of_business_id', [])).find(
                          x => +_.get(formData, `${i}.nature_of_business_id`) === +x.value,
                        )
                      }
                      onChange={handleChangeNature(item, 'nature_of_business_id', '_nature_business_name')}
                      options={handleFilterLineBusinessInfo(_.get(item, 'line_of_business_id')) || []}
                      placeholder="Select Fix Tax..."
                      className="react-select-container"
                      classNamePrefix="react-select"
                    />
                  </td>
                  <td className="border-top p-2">
                    <input
                      className="form-control"
                      type="number"
                      id={item.capitalization}
                      onChange={handleChangeInput(item, 'capitalization')}
                      value={
                        _.get(
                          _.find(formData, x => x.id === item.id) || {},
                          'capitalization',
                        ) || ''
                      }
                    />
                  </td>
                  <td className="border-top p-2">
                    <Select
                      value={
                        handleFilterMayorFee(_.get(item, 'line_of_business_id', []), _.get(item, 'nature_of_business_id')).find(
                          x => +_.get(formData, `${i}.mayors_fee`) === +x.value,
                        )
                      }
                      onChange={handleChangeSelect(item, 'mayors_fee', 'mayors_fee_label')}
                      options={handleFilterMayorFee(_.get(item, 'line_of_business_id', []), _.get(item, 'nature_of_business_id'))}
                      placeholder="Select Fix Tax..."
                      className="react-select-container"
                      classNamePrefix="react-select"
                    />
                  </td>
                </tr>
              ))
            )}
          </React.Fragment>
        )}
      </tbody>
    </table>
  );
}

BusinessActivityNewPermit.propTypes = {
  data: PropTypes.instanceOf(Array).isRequired,
  mode: PropTypes.instanceOf(Object).isRequired,
  handleChangeInput: PropTypes.instanceOf(Function).isRequired,
  handleChangeSelect: PropTypes.instanceOf(Function).isRequired,
  handleChangeNature: PropTypes.instanceOf(Function).isRequired,
  handleFilterLineBusinessInfo: PropTypes.instanceOf(Function).isRequired,
  handleFilterMayorFee: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    actions,
  ),
]);


export default enhance(BusinessActivityNewPermit);
